import React, {
  ButtonHTMLAttributes,
  FunctionComponent,
  ReactNode,
} from "react";
import classnames from 'classnames';

import { ButtonLoader } from "@components/common/loader/main";

interface ButtonProps {
  styleClassNames: StyleClassNames;
  variantName: string;
  icon?: string;
  iconSize?: number;
  isLoading?: boolean;
  loadingCopy?: string;
  size?: ButtonSize;
}

type StyleClassNames = {
  [key: string]: string;
}
type ButtonSize = 'small' | 'medium' | 'large';

const baseName = 'button';

const BaseButton: FunctionComponent<ButtonProps & ButtonHTMLAttributes<HTMLButtonElement>> = (
  props
) => {
  const {
    children,
    className,
    icon,
    iconSize,
    isLoading,
    loadingCopy,
    onClick,
    size,
    styleClassNames,
    tabIndex = 0,
    type = "button",
    variantName,
    ...buttonProps
  } = props;

  const renderContent = (): ReactNode => {
    if (!isLoading) {
      return children;
    }

    if (loadingCopy) {
      return <><ButtonLoader className={styleClassNames['button-loader']} />{loadingCopy}</>;
    }

    return <><ButtonLoader className={styleClassNames['button-loader']} />{children}</>;
  };

  const renderIcon = (): ReactNode => {
    if (isLoading || !icon) return null;
    const inlineIconStyle = iconSize ? { fontSize: `${iconSize}px` } : undefined;

    return (
      <span
        className={`${icon} ${styleClassNames.icon || ''}`}
        style={inlineIconStyle}
      />
    );
  };

  return (
    <button
      {...buttonProps}
      className={classnames(
        `bf-${baseName}__${variantName}`, // base-variant class for post consumption styling
        styleClassNames[variantName], // class for css modules
        className, // user specified class
        size ? { [styleClassNames[size]]: size } : undefined,
        { [styleClassNames.loading]: isLoading },
        { loading: isLoading },
      )}
      onClick={isLoading ? undefined : onClick}
      tabIndex={tabIndex}
      type={type}
    >
      {renderIcon()}
      {renderContent()}
    </button>
  );
};

export default BaseButton;
